import * as classnames from 'classnames';
import * as React from 'react';
import styled from 'styled-components';
import { ZoomIcon } from 'elc-icons';
import { ContentSpacing } from 'elc-base-theme';
import { observer } from 'mobx-react';
import { ProductZoomButtonTheme } from '../../../theme/default-theme';
import { lazyInject, serviceNames } from '../../../service-setup/diContainer';
import { ProductZoomButtonViewController } from '../../controllers/ProductZoomButtonViewController';

interface IProductZoomButton {
    className?: string;
    index: number;
    showIcon?: boolean;
}

interface IProductZoomButtonWrapper {
    isOverlay: boolean;
}

const ProductZoomButtonWrapper = styled.button<IProductZoomButtonWrapper>`
    box-sizing: border-box;
    cursor: zoom-in;
    display: block;
    height: ${({ isOverlay }) => (isOverlay ? '100%' : 'auto')};
    left: 0;
    margin: 0;
    padding: 0;
    position: ${({ isOverlay }) => (isOverlay ? 'absolute' : 'relative')};
    top: 0;
    width: ${({ isOverlay }) => (isOverlay ? '100%' : 'auto')};
    ${ProductZoomButtonTheme}
`;

export const ProductZoomIconContent = styled(ZoomIcon)`
    margin: ${ContentSpacing.space12};
    pointer-events: none;
    position: absolute;
`;

const ProductZoomButtonClassNames = ['elc-product-zoom-button', 'js-product-zoom-button'];
const ProductZoomIconClassNames = classnames('elc-product-zoom-icon', 'js-product-zoom-icon');

@observer
export class ProductZoomButton extends React.Component<IProductZoomButton> {
    @lazyInject(serviceNames.productZoomButtonViewController)
    private productZoomButtonViewController: ProductZoomButtonViewController;

    private handleClick = () => {
        const { index } = this.props;
        const { openZoomByIndex } = this.productZoomButtonViewController;

        openZoomByIndex(index);
    };

    public render() {
        const { className, showIcon = true, children } = this.props;
        const isOverlay = !children;

        return (
            <ProductZoomButtonWrapper
                className={classnames(...ProductZoomButtonClassNames, className)}
                isOverlay={isOverlay}
                onClick={this.handleClick}
            >
                {children}
                {showIcon && <ProductZoomIconContent className={ProductZoomIconClassNames} />}
            </ProductZoomButtonWrapper>
        );
    }
}
